// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__JG-P3","buttons":"CookieConsent_buttons__k7K9L","secondary":"CookieConsent_secondary__byhnS"};